<template>
  <TableCell
    :tag="tag"
    :popoverDisabled="true"
    :popoverTitle="popoverTitle"
    :showingPopover="showingPopover"
    :selectedCells="selectedCells"
    :columnSelectionCode="columnSelectionCode"
    @update:showingPopover="value => $emit('update:showingPopover', value)"
    @update:columnSelectionCode="value => $emit('update:columnSelectionCode', value)"
  >
    <slot>
      {{ convertedValueString }}
      <span v-html="convertedUnitHtml"></span>
    </slot>

    <template #BinSelectionInput>
      <slot name="BinSelectionInput"></slot>
    </template>

    <template #PopoverContentDesktop="{helpText}">
      <div class="status-value-popover">
        <h3 style="font-weight: bold; min-width: 150px;">
          <span v-html="popoverTitle"></span>
        </h3>
        <div class="helpText" v-html="helpText"></div>
        <slot name="popover-content"></slot>
      </div>
    </template>
  </TableCell>
</template>

<script>
import TableCell from "./TableCell.vue";
import { convertedUnitHtml } from "./units.js";

export default {
  components: { TableCell },
  props: [
    "tag",
    "unit",
    "precision",
    "popoverTitle",
    "showingPopover",
    "columnSelectionCode",
    "selectedCells"
  ],
  computed: {
    convertedValueString() {
      return this.tag.$convertedValueString(this.precision, this.unit);
    },
    popoverWidth() {
      return this.helpText ? "545px" : "initial";
    },
    convertedUnitHtml() {
      return convertedUnitHtml(this.unit ?? this.tag.$unit());
    }
  }
}
</script>

<style>
.status-value-popover {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: v-bind(popoverWidth)
}
</style>